import { Link } from 'react-router-dom'
import { useSession } from '../lib/session'
import { useFamily, usePlans } from '../lib/queries'
import { Avatar, Loading, Meter, Pill } from '../components/ui'
import { ChevronIcon } from '../components/Icons'

export function Family() {
  const { isParent, setViewedMemberId } = useSession()
  const { data: overview, isLoading } = useFamily()
  const { data: plans } = usePlans('upcoming')

  if (isLoading) return <Loading />

  const pending = plans?.filter((plan) => plan.status === 'requested') ?? []

  return (
    <div className="page">
      <h1 className="title">Family</h1>

      <Link to="/plans" className="card" style={{ textDecoration: 'none', color: 'inherit' }}>
        <div className="row-between">
          <div>
            <h2 className="title">Plans</h2>
            <p className="subtitle">
              {pending.length > 0
                ? `${pending.length} waiting for a parent`
                : 'Nothing waiting for approval'}
            </p>
          </div>
          <div className="row">
            {pending.length > 0 ? <Pill tone="warn">{pending.length}</Pill> : null}
            <ChevronIcon />
          </div>
        </div>
      </Link>

      <section className="card">
        <h2 className="title">Where everyone is at</h2>
        <div className="list">
          {(overview ?? []).map((row) => (
            <div key={row.member.id} className="stack" style={{ gap: 'var(--space-2)' }}>
              <div className="row">
                <Avatar emoji={row.member.emoji} color={row.member.color} ring />
                <div className="grow">
                  <div className="row-between">
                    <span style={{ fontWeight: 700 }}>{row.member.name}</span>
                    {/* Ready for Tomorrow is a kid rule; parents just get labelled. */}
                    {row.member.role === 'parent' ? (
                      <Pill>Parent</Pill>
                    ) : row.ready.ready ? (
                      <Pill tone="ok">Ready</Pill>
                    ) : (
                      <Pill tone="warn">{row.ready.gates.filter((g) => !g.done).length} to go</Pill>
                    )}
                  </div>
                  <div className="faint tabular">
                    Chores {row.dailyDone}/{row.dailyTotal} · {row.pointsThisWeek} pts
                    {row.connectionMet ? ' · connected' : ''}
                  </div>
                </div>
              </div>
              <Meter
                value={row.dailyDone}
                max={Math.max(row.dailyTotal, 1)}
                tone={row.dailyDone === row.dailyTotal ? 'ok' : 'accent'}
                label={`${row.member.name} daily responsibilities`}
              />
              {isParent ? (
                <button
                  type="button"
                  className="btn btn-quiet"
                  onClick={() => setViewedMemberId(row.member.id)}
                >
                  View {row.member.name}’s lists
                </button>
              ) : null}
            </div>
          ))}
        </div>
      </section>

      <div className="stack">
        <Link to="/agreement" className="btn btn-ghost btn-block">
          Our family agreement
        </Link>
        {isParent ? (
          <Link to="/settings" className="btn btn-ghost btn-block">
            Settings
          </Link>
        ) : null}
      </div>
    </div>
  )
}
